import { parseISO, isValid } from 'date-fns';

export const parseDate = dateString => {
    if (!dateString) return null;

    // Try parsing as ISO first
    let parsedDate = parseISO(dateString);
    if (isValid(parsedDate)) return parsedDate;

    // Try parsing as GMT date string
    parsedDate = new Date(dateString);
    return isValid(parsedDate) ? parsedDate : null;
};
